<template>
  <main>
    <tab-bulletin-board-header />
    <div class="tab-content">
      <div class="tab-pane active show">
          
        <click-rate-view 
        :status="status"
        v-show="status==='STATUS_CliCK_RATE_VIEW'"
        @change-status="changeStatus"
        />

        <!-- 成效 -->
        <effectiveness
        :status="status"
        :message_id="message_id"
        v-show="status==='STATUS_EFFECTIVENESS'"
        @change-status="changeStatus"
        />
      </div>
    </div>

  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import { debuglog } from 'util';
// components
import TabBulletinBoardHeader from './components/TabBulletinBoardHeader'
import ClickRateView from './components/ClickRateView'
import Effectiveness from './components/Effectiveness'

export default {
  name: 'BulletinBoardTab1',
  mixins: [commonMixin],
  components: {
    TabBulletinBoardHeader, ClickRateView, Effectiveness
  },
  computed: {
    ...mapGetters([
      'QueryKeyword'
    ])
  },
  data () {
    return {
      status: 'STATUS_CliCK_RATE_VIEW',
      message_id: {},
    }
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    changeStatus(type,id) {
      this.status = type;
      this.message_id = id
    }
  },
  beforeMount () {
  },
  mounted () {
   
    
  }
}
</script>
